<main class="container">
    <div class="row error-page align-items-center">
        <div class="error-page-content col-12 col-md-6">
            <h1>{{message['warnPageNotFound']}}</h1>
            <p>{{message['thePageYouWereLookingForCouldNotBeFound']}}
                <br /> {{message['followHomePageLinkBellow']}}
            </p>
            <a class="btn btn-primary" routerLink="/user-access">{{message['goToHomePage']}}</a>
        </div>
        <div class="error-page-image col-12 col-md-6">
            <img class="error-page-image" alt="Page not found"
                src="./assets/images/vud/error-pages/page_not_found.svg" />
        </div>
    </div>
</main>
